// Varo Theme — Main JavaScript

// Add to Cart via AJAX
function addToCartFeedback(btn, variantId) {
  if (btn.disabled) return;
  const original = btn.textContent;
  btn.disabled = true;

  if (variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
    .then(res => res.json())
    .then(() => {
      btn.textContent = (window.varoStrings && window.varoStrings.added) || 'Dodano ✓';
      btn.classList.add('bg-brand-charcoal', 'text-brand-sand', 'border-brand-charcoal');
      updateCartCount();
      openCartDrawer();
      setTimeout(() => {
        btn.textContent = original;
        btn.disabled = false;
        btn.classList.remove('bg-brand-charcoal', 'text-brand-sand', 'border-brand-charcoal');
      }, 1800);
    })
    .catch(() => {
      btn.textContent = 'Error';
      setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1800);
    });
  } else {
    // No variant ID — do nothing (prevents fake "Added" feedback)
    btn.disabled = false;
  }
}

function updateCartCount() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const badge = document.getElementById('cart-count');
      if (badge) {
        badge.textContent = cart.item_count;
        if (cart.item_count > 0) {
          badge.classList.remove('hidden');
          badge.classList.add('flex');
        } else {
          badge.classList.add('hidden');
          badge.classList.remove('flex');
        }
      }
    });
}

// ── Cart Drawer ──

function openCartDrawer() {
  fetchAndRenderCart().then(() => {
    var overlay = document.getElementById('cart-drawer-overlay');
    if (overlay) {
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
  });
}

function closeCartDrawer() {
  var overlay = document.getElementById('cart-drawer-overlay');
  if (overlay) {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
}

function fetchAndRenderCart() {
  return fetch('/cart.js')
    .then(function(res) { return res.json(); })
    .then(function(cart) {
      renderCartDrawerItems(cart);
      renderCartDrawerFooter(cart);
      renderCartDrawerRecs(cart);
      // Update header badge
      var badge = document.getElementById('cart-count');
      if (badge) {
        badge.textContent = cart.item_count;
        if (cart.item_count > 0) { badge.classList.remove('hidden'); badge.classList.add('flex'); }
        else { badge.classList.add('hidden'); badge.classList.remove('flex'); }
      }
      // Update drawer count
      var drawerCount = document.getElementById('cart-drawer-count');
      if (drawerCount) drawerCount.textContent = cart.item_count;
    });
}

function renderCartDrawerItems(cart) {
  var container = document.getElementById('cart-drawer-items');
  var emptyState = document.getElementById('cart-drawer-empty');
  var footer = document.getElementById('cart-drawer-footer');
  if (!container) return;

  if (cart.item_count === 0) {
    container.innerHTML = '';
    if (emptyState) emptyState.classList.remove('hidden');
    if (footer) footer.classList.add('hidden');
    return;
  }

  if (emptyState) emptyState.classList.add('hidden');
  if (footer) footer.classList.remove('hidden');

  container.innerHTML = cart.items.map(function(item) {
    var variantTitle = item.variant_title || '';
    var imageUrl = item.image
      ? item.image.replace(/(\.[^.]+)$/, '_200x$1')
      : 'https://placehold.co/200x200/F5F0EB/111111?text=No+Image';

    var vs = window.varoStrings || {};
    var sizeMap = {'Small': vs.sizeSmall || 'Small', 'Tall': vs.sizeTall || 'Tall', 'Round': vs.sizeRound || 'Round', 'Ball D6cm': vs.sizeBall || 'Ball 6cm'};
    var displayTitle = (item.product_title || '').replace('Door Handle - ', '');
    for (var sk in sizeMap) { displayTitle = displayTitle.replace(' - ' + sk, ' - ' + sizeMap[sk]); }
    return '<div class="cart-drawer-item flex gap-4 py-5 border-b border-brand-charcoal/10" data-line-key="' + item.key + '">' +
      '<a href="' + item.url + '" class="shrink-0 hover-target">' +
        '<img src="' + imageUrl + '" alt="' + displayTitle + '" class="w-20 h-20 bg-[#EBEBEB] object-contain">' +
      '</a>' +
      '<div class="flex-1 flex flex-col justify-between min-w-0">' +
        '<div>' +
          '<a href="' + item.url + '" class="block text-sm text-brand-charcoal font-light hover:text-brand-gold transition-colors truncate">' + displayTitle + '</a>' +
          (variantTitle ? '<p class="text-[10px] text-brand-muted tracking-wide mt-0.5">' + variantTitle + '</p>' : '') +
        '</div>' +
        '<div class="flex items-center justify-between mt-2">' +
          '<div class="flex items-center border border-brand-charcoal/20">' +
            '<button onclick="updateCartItem(\'' + item.key + '\', ' + (item.quantity - 1) + ')" class="w-8 h-8 flex items-center justify-center text-brand-charcoal hover:bg-brand-charcoal hover:text-brand-sand transition-all duration-300 hover-target" aria-label="Decrease quantity">' +
              '<svg class="w-3 h-3" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M20 12H4"/></svg>' +
            '</button>' +
            '<span class="w-8 h-8 flex items-center justify-center text-xs font-light border-x border-brand-charcoal/20">' + item.quantity + '</span>' +
            '<button onclick="updateCartItem(\'' + item.key + '\', ' + (item.quantity + 1) + ')" class="w-8 h-8 flex items-center justify-center text-brand-charcoal hover:bg-brand-charcoal hover:text-brand-sand transition-all duration-300 hover-target" aria-label="Increase quantity">' +
              '<svg class="w-3 h-3" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M12 4v16M4 12h16"/></svg>' +
            '</button>' +
          '</div>' +
          '<span class="text-sm text-brand-charcoal font-light">' + formatMoney(item.final_line_price) + '</span>' +
        '</div>' +
      '</div>' +
      '<button onclick="removeCartItem(\'' + item.key + '\')" class="self-start text-brand-muted hover:text-brand-charcoal transition-colors mt-0.5 hover-target" aria-label="Remove item">' +
        '<svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"><path d="M6 18L18 6M6 6l12 12" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</button>' +
    '</div>';
  }).join('');
}

function renderCartDrawerFooter(cart) {
  var subtotalEl = document.getElementById('cart-drawer-subtotal');
  if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
}

function updateCartItem(key, quantity) {
  if (quantity < 1) { removeCartItem(key); return; }
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: quantity })
  })
  .then(function(res) { return res.json(); })
  .then(function() { fetchAndRenderCart(); });
}

function removeCartItem(key) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  })
  .then(function(res) { return res.json(); })
  .then(function() { fetchAndRenderCart(); });
}

function formatMoney(cents) {
  if (typeof window.Shopify !== 'undefined' && window.Shopify.currency && window.Shopify.currency.active) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: window.Shopify.currency.active
    }).format(cents / 100);
  }
  return '\u20AC' + (cents / 100).toFixed(2).replace('.', ',');
}

var _drawerRecsCache = null;
function renderCartDrawerRecs(cart) {
  var container = document.getElementById('cart-drawer-recs');
  if (!container) return;

  var cartIds = cart.items.map(function(i) { return i.product_id; });

  function render(products) {
    var recs = products.filter(function(p) {
      return cartIds.indexOf(p.id) === -1;
    }).slice(0, 8);
    if (recs.length === 0) { container.innerHTML = ''; return; }

    container.innerHTML =
      '<div class="border-t border-brand-charcoal/10 mt-2 pt-5 pb-4">' +
        '<p class="text-[10px] tracking-[0.2em] uppercase text-brand-muted font-medium mb-4">' + (window.varoStrings && window.varoStrings.youMayLike || 'Może Ci się spodobać') + '</p>' +
        '<div class="flex gap-3 overflow-x-auto pb-3" style="-webkit-overflow-scrolling:touch;">' +
          recs.map(function(p) {
            var img = p.images[0];
            var imgSrc = img ? img.src.replace(/(\.[^.]+)$/, '_300x$1') : '';
            var price = formatMoney(Math.round(parseFloat(p.variants[0].price) * 100));
            var url = '/products/' + p.handle;
            var variantId = p.variants[0].id;
            // Clean title: strip "Door Handle - " prefix, translate size labels via locale
            var vs = window.varoStrings || {};
            var sizeMap = {'Small': vs.sizeSmall || 'Small', 'Tall': vs.sizeTall || 'Tall', 'Round': vs.sizeRound || 'Round', 'Ball D6cm': vs.sizeBall || 'Ball 6cm'};
            var displayTitle = (p.title || '').replace('Door Handle - ', '');
            // Translate the size suffix if present
            for (var sk in sizeMap) { displayTitle = displayTitle.replace(' - ' + sk, ' - ' + sizeMap[sk]); }
            // For single-variant products without a " - ", append translated size
            if (displayTitle.indexOf(' - ') === -1) {
              var firstVariantTitle = p.variants[0] && p.variants[0].title;
              if (firstVariantTitle && firstVariantTitle !== 'Default Title') {
                displayTitle += ' - ' + (sizeMap[firstVariantTitle] || firstVariantTitle);
              }
            }
            return '<div class="shrink-0 w-[140px]">' +
              '<a href="' + url + '" onclick="closeCartDrawer()" class="block hover-target">' +
                '<div class="aspect-square bg-[#EBEBEB] overflow-hidden">' +
                  (imgSrc ? '<img src="' + imgSrc + '" alt="' + displayTitle + '" class="w-full h-full object-contain" loading="lazy">' : '') +
                '</div>' +
                '<p class="text-[11px] text-brand-charcoal font-light mt-2 truncate">' + displayTitle + '</p>' +
                '<p class="text-[11px] text-brand-charcoal font-light">' + price + '</p>' +
              '</a>' +
              '<button onclick="addToCartFeedback(this, ' + variantId + ')" class="add-to-cart mt-1.5 w-full py-2 text-[9px] tracking-[0.12em] uppercase border border-brand-charcoal/20 hover:bg-brand-charcoal hover:text-brand-sand transition-all duration-300 hover-target">' + (window.varoStrings && window.varoStrings.addToCart || 'Dodaj do koszyka') + '</button>' +
            '</div>';
          }).join('') +
        '</div>' +
      '</div>';
  }

  if (_drawerRecsCache) {
    render(_drawerRecsCache);
  } else {
    fetch('/collections/all/products.json?limit=20')
      .then(function(res) { return res.json(); })
      .then(function(data) {
        _drawerRecsCache = data.products;
        render(data.products);
      })
      .catch(function() { container.innerHTML = ''; });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // 0. Smooth scroll for anchor links (e.g. #shop)
  document.querySelectorAll('a[href^="#"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var targetId = this.getAttribute('href');
      if (targetId.length <= 1) return; // skip bare "#"
      var target = document.querySelector(targetId);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  // 1. Custom cursor
  const cursorDot = document.querySelector('.cursor-dot');
  const cursorOutline = document.querySelector('.cursor-outline');

  if (window.matchMedia("(pointer: fine)").matches && cursorDot && cursorOutline) {
    document.addEventListener('mousemove', (e) => {
      cursorDot.style.left = e.clientX + 'px';
      cursorDot.style.top = e.clientY + 'px';
      cursorOutline.animate({
        left: e.clientX + 'px',
        top: e.clientY + 'px'
      }, { duration: 300, fill: "forwards" });
    });

    document.querySelectorAll('.hover-target').forEach(el => {
      el.addEventListener('mouseenter', () => {
        cursorDot.classList.add('is-hovering');
        cursorOutline.classList.add('is-hovering');
      });
      el.addEventListener('mouseleave', () => {
        cursorDot.classList.remove('is-hovering');
        cursorOutline.classList.remove('is-hovering');
      });
    });
  }

  // 2. Intersection Observer for Scroll Reveals
  const revealOnScroll = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: "0px 0px -50px 0px" });

  document.querySelectorAll('.revealable').forEach(el => revealOnScroll.observe(el));

  // 3. Mobile Menu Toggle
  const menuToggle = document.getElementById('menu-toggle');
  const mobileMenu = document.getElementById('mobile-menu');
  if (menuToggle && mobileMenu) {
    const mobileNavLinks = mobileMenu.querySelectorAll('a');
    menuToggle.addEventListener('click', () => {
      const isOpen = mobileMenu.classList.toggle('is-open');
      menuToggle.classList.toggle('is-open');
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
    mobileNavLinks.forEach(link => {
      link.addEventListener('click', () => {
        mobileMenu.classList.remove('is-open');
        menuToggle.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });
  }

  // 4. Dynamic Header blend
  const header = document.getElementById('navbar');
  const heroSection = document.querySelector('section');
  if (header && heroSection) {
    const updateHeaderBlend = () => {
      const heroBottom = heroSection.offsetTop + heroSection.offsetHeight;
      if (window.scrollY >= heroBottom - 80) {
        header.classList.add('mix-blend-difference');
      } else {
        header.classList.remove('mix-blend-difference');
      }
    };
    window.addEventListener('scroll', updateHeaderBlend, { passive: true });
    updateHeaderBlend();
  }

  // 5. Drag-to-scroll for horizontal sections
  ['category-scroll', 'material-scroll', 'featured-scroll'].forEach(id => {
    const el = document.getElementById(id);
    if (!el) return;
    let isDown = false, startX, scrollL;
    el.addEventListener('mousedown', (e) => {
      isDown = true;
      startX = e.pageX - el.offsetLeft;
      scrollL = el.scrollLeft;
      e.preventDefault();
    });
    el.addEventListener('mouseleave', () => { isDown = false; });
    el.addEventListener('mouseup', () => { isDown = false; });
    el.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - el.offsetLeft;
      el.scrollLeft = scrollL - (x - startX) * 1.5;
    });
  });

  // 6. Marquee drag-to-browse (JS-driven loop so drag position is preserved)
  const marqueeSection = document.getElementById('marquee-section');
  const marqueeEl = marqueeSection ? marqueeSection.querySelector('.animate-marquee') : null;
  if (marqueeSection && marqueeEl) {
    // Disable the CSS keyframe animation — we control position manually
    marqueeEl.style.animation = 'none';

    let offset = 0;             // current translateX in pixels (negative = moved left)
    let halfWidth = marqueeEl.scrollWidth / 2; // content is duplicated, loop point = half
    const speed = 52;           // pixels per second (tweak for taste)
    let lastTs = 0;
    let paused = false;
    let dragging = false;
    let startX = 0;
    let startOffset = 0;

    // Recalculate half width when images finish loading
    const recalc = () => { halfWidth = marqueeEl.scrollWidth / 2; };
    window.addEventListener('load', recalc);
    window.addEventListener('resize', recalc);

    const tick = (ts) => {
      if (!lastTs) lastTs = ts;
      const dt = (ts - lastTs) / 1000;
      lastTs = ts;
      if (!paused && !dragging && halfWidth > 0) {
        offset -= speed * dt;
        if (offset <= -halfWidth) offset += halfWidth;
      }
      marqueeEl.style.transform = 'translateX(' + offset + 'px)';
      requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);

    // Pause on hover (desktop fine-pointer only)
    if (window.matchMedia('(hover: hover)').matches) {
      marqueeSection.addEventListener('mouseenter', () => { paused = true; });
      marqueeSection.addEventListener('mouseleave', () => { paused = false; });
    }

    // Mouse drag
    marqueeSection.addEventListener('mousedown', (e) => {
      dragging = true;
      startX = e.clientX;
      startOffset = offset;
      marqueeSection.style.cursor = 'grabbing';
      e.preventDefault();
    });
    window.addEventListener('mousemove', (e) => {
      if (!dragging) return;
      offset = startOffset + (e.clientX - startX);
      // Keep offset within the loop range so animation resumes cleanly
      if (halfWidth > 0) {
        while (offset <= -halfWidth) offset += halfWidth;
        while (offset > 0) offset -= halfWidth;
      }
    });
    window.addEventListener('mouseup', () => {
      if (!dragging) return;
      dragging = false;
      marqueeSection.style.cursor = 'grab';
    });

    // Touch drag
    marqueeSection.addEventListener('touchstart', (e) => {
      dragging = true;
      startX = e.touches[0].clientX;
      startOffset = offset;
    }, { passive: true });
    window.addEventListener('touchmove', (e) => {
      if (!dragging) return;
      offset = startOffset + (e.touches[0].clientX - startX);
      if (halfWidth > 0) {
        while (offset <= -halfWidth) offset += halfWidth;
        while (offset > 0) offset -= halfWidth;
      }
    }, { passive: true });
    window.addEventListener('touchend', () => {
      if (!dragging) return;
      dragging = false;
    });
  }

  // 7. Reviews Carousel
  const reviewsTrack = document.getElementById('reviews-track');
  if (reviewsTrack) {
    const slides = reviewsTrack.children;
    const totalSlides = slides.length;
    let currentPage = 0;
    let perPage = window.innerWidth >= 768 ? 3 : 1;
    let totalPages = Math.ceil(totalSlides / perPage);
    let autoplayTimer;

    function goToPage(page) {
      currentPage = page;
      const offset = currentPage * (100 / perPage) * perPage;
      reviewsTrack.style.transform = 'translateX(-' + offset + '%)';
      resetAutoplay();
    }
    function nextPage() { goToPage((currentPage + 1) % totalPages); }
    function resetAutoplay() {
      clearInterval(autoplayTimer);
      autoplayTimer = setInterval(nextPage, 5000);
    }
    function handleResize() {
      const newPerPage = window.innerWidth >= 768 ? 3 : 1;
      if (newPerPage !== perPage) {
        perPage = newPerPage;
        totalPages = Math.ceil(totalSlides / perPage);
        currentPage = 0;
        reviewsTrack.style.transform = 'translateX(0)';
        resetAutoplay();
      }
    }
    resetAutoplay();
    window.addEventListener('resize', handleResize);

    const prevBtn = document.getElementById('review-prev');
    const nextBtn = document.getElementById('review-next');
    if (prevBtn) prevBtn.addEventListener('click', () => goToPage((currentPage - 1 + totalPages) % totalPages));
    if (nextBtn) nextBtn.addEventListener('click', () => nextPage());

    // Keyboard navigation for carousel
    const carousel = document.getElementById('reviews-carousel');
    if (carousel) {
      carousel.setAttribute('role', 'region');
      carousel.setAttribute('aria-label', 'Customer reviews');
      carousel.setAttribute('tabindex', '0');
      carousel.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); goToPage((currentPage - 1 + totalPages) % totalPages); }
        if (e.key === 'ArrowRight') { e.preventDefault(); nextPage(); }
      });
    }
  }

  // 8. Trust Ticker (mobile)
  const ticks = document.querySelectorAll('.trust-tick');
  if (ticks.length > 0) {
    let tickIdx = 0;
    setInterval(() => {
      ticks[tickIdx].classList.remove('opacity-100');
      ticks[tickIdx].classList.add('opacity-0');
      tickIdx = (tickIdx + 1) % ticks.length;
      ticks[tickIdx].classList.remove('opacity-0');
      ticks[tickIdx].classList.add('opacity-100');
    }, 3000);
  }

  // 9. Mobile Sticky Cart Bar
  const stickyCart = document.getElementById('mobile-sticky-cart');
  const featuredSection = document.getElementById('featured');
  if (stickyCart && featuredSection) {
    const productObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          stickyCart.classList.remove('translate-y-full');
          stickyCart.classList.add('translate-y-0');
        } else {
          stickyCart.classList.add('translate-y-full');
          stickyCart.classList.remove('translate-y-0');
        }
      });
    }, { threshold: 0.1 });
    productObserver.observe(featuredSection);
  }

  // 10. Back to Top
  const backToTop = document.getElementById('back-to-top');
  if (backToTop) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 600) {
        backToTop.classList.remove('opacity-0', 'pointer-events-none', 'translate-y-4');
        backToTop.classList.add('opacity-100', 'pointer-events-auto', 'translate-y-0');
      } else {
        backToTop.classList.add('opacity-0', 'pointer-events-none', 'translate-y-4');
        backToTop.classList.remove('opacity-100', 'pointer-events-auto', 'translate-y-0');
      }
    }, { passive: true });
    backToTop.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  // 11. Parallax (throttled via rAF)
  const parallaxImages = document.querySelectorAll('.parallax-img');
  const heroImg = document.getElementById('hero-img');
  if (parallaxImages.length || heroImg) {
    let parallaxTicking = false;
    window.addEventListener('scroll', () => {
      if (!parallaxTicking) {
        parallaxTicking = true;
        requestAnimationFrame(() => {
          const scrollY = window.pageYOffset;
          parallaxImages.forEach(img => {
            const offset = Math.max(0, scrollY - img.closest('section').offsetTop);
            img.style.transform = 'translateY(' + (offset * 0.15) + 'px)';
          });
          if (heroImg) {
            heroImg.style.transform = 'translateY(' + (scrollY * 0.3) + 'px) scale(1.05)';
          }
          parallaxTicking = false;
        });
      }
    }, { passive: true });
  }

  // 12. Search Overlay
  const searchOverlay = document.getElementById('search-overlay');
  const searchInput = document.getElementById('search-input');
  const searchClose = document.getElementById('search-close');
  const desktopSearchBtn = document.getElementById('desktop-search-btn');
  const mobileSearchBtn = document.getElementById('mobile-search-btn');

  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(() => { if (searchInput) searchInput.focus(); }, 200);
    // Close mobile menu if open
    const mm = document.getElementById('mobile-menu');
    const mt = document.getElementById('menu-toggle');
    if (mm && mm.classList.contains('is-open')) {
      mm.classList.remove('is-open');
      if (mt) mt.classList.remove('is-open');
    }
  }

  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
    if (searchInput) searchInput.value = '';
  }

  if (desktopSearchBtn) desktopSearchBtn.addEventListener('click', openSearch);
  if (mobileSearchBtn) mobileSearchBtn.addEventListener('click', openSearch);
  if (searchClose) searchClose.addEventListener('click', closeSearch);
  if (searchOverlay) {
    searchOverlay.addEventListener('click', (e) => { if (e.target === searchOverlay) closeSearch(); });
  }
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && searchOverlay && searchOverlay.classList.contains('is-open')) closeSearch();
    if ((e.key === 'k' || e.key === 'K') && (e.metaKey || e.ctrlKey)) { e.preventDefault(); openSearch(); }
  });

  // 13. Sort select — submit on change (collection page)
  const sortSelect = document.getElementById('sort-select');
  const sortForm = document.getElementById('sort-form');
  if (sortSelect && sortForm) {
    sortSelect.addEventListener('change', () => sortForm.submit());
  }

  // 14. Update cart count on load
  updateCartCount();

  // 15. Cart Drawer — close on overlay click & Escape key
  var cartOverlay = document.getElementById('cart-drawer-overlay');
  if (cartOverlay) {
    cartOverlay.addEventListener('click', function(e) {
      if (e.target === cartOverlay) closeCartDrawer();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && cartOverlay.classList.contains('is-open')) {
        closeCartDrawer();
      }
    });
  }
});
